import Dialog from '@material-ui/core/Dialog';
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
// import { InputField, InputFieldWithCheckbox, LabelField, MyCheckbox } from 'components';
import { InputField, InputFieldWithCheckbox, LabelField, MyCheckbox, HintField } from 'components';
import { getIn } from 'formik';
import { DateTimePickerField } from 'components/DateTime/DateTimePicker';
import { getDateTimeFormat, getDateTimeFormatForDatePicket, maskDateTime } from 'helper';
import moment from 'moment-timezone';
import AddNewTag from "pages/Members/MemberDetails/AddNewTag";
import React, { useCallback, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Select, { components } from "react-select";
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import ClassUploadCoverImage from './FormUploadCoverImage';
import Wysiwyg from './Wysiwyg';
import MyButton from 'components/MyButton';
import InfoTooltip from 'components/InfoTooltip';
import { fontConfig } from "theme/fontConfig";

const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;



const FormInfo = ({ formik, coverImage, setCoverImage, handleOpenCoverImage, croppedImage }) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();

  const [maxDate, setMaxDate] = useState('');
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");
  const [loading, setLoading] = useState(false);
  const [openTag, setOpenTag] = useState(false);
  const [openAccountTag, setOpenAccountTag] = useState(false);

  const dateTimeMask = maskDateTime();


  useEffect(() => {
    // const currentDate = new Date();
    // const maxDate = new Date(
    //   currentDate.getFullYear() + 100,
    //   currentDate.getMonth(),
    //   currentDate.getDate()
    // );
    // setMaxDate(maxDate.toISOString().slice(0, 10));

    const maxDate = new Date();
    const maximumDate = maxDate.setFullYear(maxDate.getFullYear() + 100);
    setMaxDate(maximumDate);
  }, []);

  const minDate = getESTDateForPicker(new Date());

  const deleteTag = async (tag) => {
    formik.setFieldValue(
      'formDetails.tags',
      formik.values?.formDetails?.tags?.filter((item) => item !== tag)
    );
  };


  // Always display and select in America/New_York (EST/EDT)
  function getESTDateForPicker(date) {
    if (!date) return null;
    // Convert UTC date string to America/New_York, then return a JS Date in that wall time
    const m = moment.tz(date, 'UTC').tz('America/New_York');
    // Return a Date object with the correct wall time (but local timezone)
    return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond());
  }

  // When user picks a date, treat it as America/New_York wall time, convert to UTC for storage
  function setESTDateToUTC(date, name) {
    if (!date) return null;
    // The date object is in local time, but we want to treat it as America/New_York
    const m = moment.tz([
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    ], 'America/New_York');
    const utcDate = m.utc().toDate();
    formik.setFieldValue(name, utcDate);
    return utcDate;
  }
  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes())
    );
    formik.setFieldValue(name, date);
    return date;
  }
  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }



  const generateYearsHandler = () => {
    const currentYear = new Date().getFullYear();
    const yearsList = [];
    for (let i = 0; i <= 2; i++) {
      const year = currentYear + i;
      yearsList.push(year.toString());
      if (i < 2) {
        yearsList.push(`${year}-${year + 1}`);
      }
    }
    return yearsList;
  }

  const formatOptionLabel = ({ key, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{key}</div>
          </div>
        </div>
      </div>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };



  return (
    <>
      <Row>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Form Name',
              name: 'formName',
              placeholder: 'Form Name',
              checkValidation: true,
            }}
            value={formik.values?.formName}
            handleChange={(e) => {
              if (!e.target?.value?.trim()?.length) {
                formik.setFieldValue('formName', '');
                return;
              }
              formik.setFieldValue('formName', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.formName === '') {
                e.preventDefault();
              }
            }}
            
            maxLength={30}
            
              onBlur={formik.handleBlur}
          />
        </Col>
        <Col className="col-sm-6">
          <InputFieldWithCheckbox
            titleStyle={{
              fontFamily: fontConfig.FormsInputFieldWithCheckboxFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            formik={formik}
            mandatory={!formik.values?.formDetails?.infiniteCapacity}
            title="Maximum Limit"
            name="formDetails.maximumCapacity"
            placeholder="Maximum Limit"
            checkValidation={true}
            handleChange={(e) => {
              const value = e?.target?.value.match(regex)[0];
              let intValue = parseInt(value) > 0 ? parseInt(value) : '';
              if (intValue > 10000) intValue = 10000;
              formik.setFieldValue('formDetails.maximumCapacity', intValue);
            }}
            value={formik.values?.formDetails?.maximumCapacity}
            max={10000}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            disabled={formik.values?.formDetails?.infiniteCapacity}
            checkbox={"formDetails.infiniteCapacity"}
            checkedBox={formik.values?.formDetails?.infiniteCapacity}
            checkboxLabel={"No Limit"}
            checkboxChange={(e) => {
              if (e?.target?.checked) {
                formik.setFieldValue('formDetails.maximumCapacity', '');
              }
              formik.setFieldValue(
                'formDetails.infiniteCapacity',
                !formik.values?.formDetails?.infiniteCapacity
              );
            }}
          />
        </Col>
      </Row>
    
      <Row className="align-items-baseline">
     
        <Col className="col-sm-6"  style={{
              fontFamily: fontConfig.FormsColFont.family,
              fontWeight: '500',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#3F4254 !important',
               marginTop: '40px'
            }}>
         Open for submissions:
        </Col>
      
      </Row>
      <Row className="align-items-baseline">
     
        <Col className="col-sm-6">
          <DateTimePickerField
            mandatory={true}
            {...{
              formik,
              title: 'From (EST)',
              name: 'formStartDate',
            }}
            checkValidation={true}
            selected={
              formik.values?.formStartDate &&
              getESTDateForPicker(formik.values?.formStartDate)
            }
            onChange={(e) => {
               
              if (formik.values?.formEndDate && e > formik.values?.formEndDate) {
                toastr.info('Validation', 'Registration Starts date should be less than Registration Ends date');
                return;
              }
              setESTDateToUTC(e, `formStartDate`);
            }}
              onBlur={() => {
    formik.setFieldTouched("formStartDate", true); 
  }}
            minDate={minDate}
            showTimeSelect={true}
            dateFormat={getDateTimeFormatForDatePicket()}
            placeholderText={getDateTimeFormat() + ' (EST/EDT)'}
            mask={dateTimeMask}
          />
      
        </Col>
        <Col className="col-sm-6" >
          <DateTimePickerField
            mandatory={true}
            {...{
              formik,
              title: 'Until (EST)',
              name: 'formEndDate',
            }}
            checkValidation={true}
            selected={
              formik.values?.formEndDate &&
              getESTDateForPicker(formik.values?.formEndDate)
            }
            onChange={(e) => {
                formik.setFieldTouched("formEndDate", true, false);
              setESTDateToUTC(e, `formEndDate`);
              //  formik.validateField("formEndDate");
            }}
              onBlur={() => {
    formik.setFieldTouched("formEndDate", true);
  }}
            alwaysAvailable={true}
            checkAvailableHandler={() => {
              if (!formik.values?.alwaysAvailable) {
                formik.setFieldValue('formEndDate', null);
              }
              formik.setFieldValue(
                'alwaysAvailable',
                !formik.values?.alwaysAvailable
              );
            }}
            disabled={
              !formik.values?.formStartDate ||
              formik.values?.alwaysAvailable
            }
            minDate={formik.values?.formStartDate ? getESTDateForPicker(formik.values?.formStartDate) : minDate}
            showTimeSelect={true}
            dateFormat={getDateTimeFormatForDatePicket()}
            placeholderText={getDateTimeFormat() + ' (EST/EDT)'}
            mask={dateTimeMask}
          />
      
        </Col>
      </Row>
      <div className='d-flex flex-wrap' style={{ marginTop: '2px', gap: '30px' }}>
        <div className="" style={!orgDetails?.memberPortal ? { opacity: "0.5", cursor: "not-allowed" } : {}}>
          <MyCheckbox
            title="Allow non-member"
            checked={formik.values?.allowNonMembers}
            handlechange={() => {
              formik.setFieldValue(
                'allowNonMembers',
                !formik.values?.allowNonMembers
              );
            }}
            titleStyles={{
              fontSize: "12px"
            }}
            disabled={!orgDetails?.memberPortal}
          />
        </div>
        {/* <div className="">
          <MyCheckbox
            title="Allow wait-list"
            checked={formik.values?.allowWaitingList}
            handlechange={() => {
              formik.setFieldValue(
                'allowWaitingList',
                !formik.values?.allowWaitingList
              );
            }}
            titleStyles={{
              fontSize: "12px"
            }}
          />
        </div> */}
        <div className="">
          <MyCheckbox
            title="Allow bill my account"
            checked={formik.values?.allowBillMyAccount}
            handlechange={() => {
              formik.setFieldValue(
                'allowBillMyAccount',
                !formik.values?.allowBillMyAccount
              );
            }}
            titleStyles={{
              fontSize: "12px"
            }}
          />
        </div>
      </div>
      <Row>
        <Col className="col-sm-12" style={{ marginTop: '40px' }}>
          <LabelField
            title="Description"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <Wysiwyg formik={formik} />
        </Col>
      </Row>
      <hr />
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-12">
          <LabelField
            title="Contact Info"
            style={{
              fontSize: "12px",
              color: "#002E5C",
              opacity: "0.7",

            }}
            className="contact-info-label"
          />
        </Col>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'First Name',
             name:"formDetails.contactInfo.firstName",
              placeholder: 'First Name',
              checkValidation: true,
            }}
            maxLength={50}
            value={formik.values?.formDetails?.contactInfo?.firstName}
            handleChange={(e) => {
              if (!e.target?.value?.trim()?.length) {
                formik.setFieldValue('formDetails.contactInfo.firstName', '');
                return;
              }
              formik.setFieldValue('formDetails.contactInfo.firstName', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.formDetails?.contactInfo?.firstName === '') {
                e.preventDefault();
              }
            }}
              onBlur={formik.handleBlur}
          />
        </Col>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Last Name',
              name:'formDetails.contactInfo.lastName',
              placeholder: 'Last Name',
              checkValidation: true,
            }}
            maxLength={50}
            value={formik.values?.formDetails?.contactInfo?.lastName}
            handleChange={(e) => {
              if (!e.target?.value?.trim()?.length) {
                formik.setFieldValue('formDetails.contactInfo.lastName', '');
                return;
              }
              formik.setFieldValue('formDetails.contactInfo.lastName', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.formDetails?.contactInfo?.lastName === '') {
                e.preventDefault();
              }
            }}
              onBlur={formik.handleBlur}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Email',
              name: 'formDetails.contactInfo.email',
              placeholder: 'Email',
              checkValidation: true,
            }}
            maxLength={80}
            value={formik.values?.formDetails?.contactInfo?.email}
            handleChange={(e) => {
              formik.setFieldValue('formDetails.contactInfo.email', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.formDetails?.contactInfo?.email === '') {
                e.preventDefault();
              }
            }}
            copy={true}
              onBlur={formik.handleBlur}
          />
        </Col>
        <Col className="col-sm-6" style={{ marginTop: '40px' }}>
          <MyCheckbox
            title="Show my email"
            checked={formik.values?.formDetails?.contactInfo?.showEmail}
            handlechange={() => {
              formik.setFieldValue(
                'formDetails.contactInfo.showEmail',
                !formik.values?.formDetails?.contactInfo?.showEmail
              );
            }}
            titleStyles={{
              fontSize: "12px"
            }}
          />
        </Col>
      </Row>
            <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <label style={{ fontFamily: fontConfig.FormsFormInfoTextFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Button Label <span style={{ color: 'red' }}>*</span></label>
            <InfoTooltip text="Customize the call-to-action button text shown on the form registration page. E.g., 'Register Now', 'Book My Spot', or 'Join Us' (max 20 characters)." />
          </div>
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            maxLength={20}
            {...{
              formik,
              title: 'none',
              name: 'formDetails.actionButtonLabel',
              placeholder: 'Button Label (Max. 20 characters)',
              checkValidation: true,
            }}
            value={formik.values?.formDetails?.actionButtonLabel}
            handleChange={(e) => {
               const value = e.target?.value;
  if (value.length <= 20) {
    formik.setFieldValue('formDetails.actionButtonLabel', e.target?.value);
  }
              // formik.setFieldValue('formDetails.actionButtonLabel', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.formDetails?.actionButtonLabel === '') {
                e.preventDefault();
              }
            }}
           onBlur={formik.handleBlur}
          />
        </Col>
        <Col className="col-sm-6" style={{ marginTop: '30px' }}>
        
         <MyButton
            content={
              formik.values?.formDetails?.actionButtonLabel
            }
                          
            style={{
              paddingLeft:'8px',
              paddingRight:'8px',
              minWidth: '96px',
              height: '36px',
             }}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-12">
          <div className="d-flex" style={{ gap: "6px", alignItems: "center" }}>
            <LabelField
              mandatory={false}
              style={{
                fontFamily: fontConfig.GeneralLabelFieldFont.family,
                fontWeight: '400',
                fontSize: '12px',
                lineHeight: '18px',
                color: '#4F4F4F',
                marginBottom: 0,
              }}
            >
              Add Contact Tags
            </LabelField>
            <InfoTooltip text='Automatically add selected tags to a contact after a form is submitted or once a “Bill My Account” charge is paid.
Example: Add a “Volunteer” tag when someone completes a volunteer form.' style={{ marginBottom: '2px' }} />
          </div>
          <div className="event_tags">
            {formik.values?.formDetails?.tags?.length > 0 && formik.values?.formDetails?.tags?.sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag, i) => {
              return (
                <span className="event_tag" key={tag}>
                  {tag}
                  <span
                    style={{
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '400',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      deleteTag(tag);
                    }}
                  >
                    x
                  </span>
                </span>
              );
            })}
            <div className="event_add-tag">
              <span
                style={{
                  color: '#B5B5C3',
                  fontFamily: fontConfig.FormsFormInfoTextFont.family,
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => setOpenTag(true)}
              >
                <strong>+</strong> Add a tag
              </span>
            </div>
          </div>
        </Col>
      </Row>
      <Row style={{ marginBottom: '40px', marginTop: '20px' }}>
        <Col className="col-sm-12">
          <div className="d-flex" style={{ gap: "6px", alignItems: "center", marginBottom: '8px' }}>
            <LabelField
              mandatory={false}
              style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '400', fontSize: '12px', lineHeight: '18px', color: '#4F4F4F', marginBottom: 0 }}
            >
              Add Account Tags
            </LabelField>
            <InfoTooltip text='Automatically add selected tags to an account after a form is submitted or once a "Bill My Account" charge is paid. Example: Add a "Volunteer" tag to the account when someone completes a volunteer form.' style={{ marginBottom: '2px' }} />
          </div>
          <div className="event_tags">
            {formik.values?.formDetails?.accountTags?.length > 0 && [...formik.values.formDetails.accountTags].sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag) => (
              <span className="event_tag" key={tag}>
                {tag}
                <span
                  style={{ marginLeft: '5px', fontSize: '12px', fontWeight: '400', cursor: 'pointer' }}
                  onClick={() => formik.setFieldValue('formDetails.accountTags', formik.values.formDetails.accountTags.filter((t) => t !== tag))}
                >
                  x
                </span>
              </span>
            ))}
            <div className="event_add-tag">
              <span
                style={{ color: '#B5B5C3', fontFamily: fontConfig.FormsFormInfoTextFont.family, fontWeight: '500', fontSize: '13px', textAlign: 'center', cursor: 'pointer' }}
                onClick={() => setOpenAccountTag(true)}
              >
                <strong>+</strong> Add a tag
              </span>
            </div>
          </div>
        </Col>
      </Row>
      <div className="tag_modal">
        <Dialog
          open={openAccountTag}
          onClose={() => setOpenAccountTag(false)}
          PaperProps={{ style: { background: "#fff", borderRadius: "10px" } }}
        >
          <AddNewTag
            setOpenTag={setOpenAccountTag}
            openTag={openAccountTag}
            addTagHandler={(tag) => {
              formik.setFieldValue('formDetails.accountTags', [...(formik.values?.formDetails?.accountTags || []), tag]);
            }}
            deleteTagHandler={(tag) => {
              formik.setFieldValue('formDetails.accountTags', (formik.values?.formDetails?.accountTags || []).filter((t) => t !== tag));
            }}
            selectedUserTag={formik.values?.formDetails?.accountTags || []}
            type="form"
            apiType="account"
          />
        </Dialog>
      </div>
      <hr />
      <Row>
        <Col className="col-sm-12">
          <LabelField
            title="Upload Cover Image (Max allowed is 5MB) (Min Image Dimension: 800x800)"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <ClassUploadCoverImage
            coverImageFile={coverImage?.name}
            handleOpenCoverImage={handleOpenCoverImage}
            croppedImage={croppedImage}
          />
        </Col>
      </Row>
      <div className="tag_modal">
        <Dialog
          open={openTag}
          onClose={() => {
            setOpenTag(false);
          }}
          PaperProps={{
            style: {
              background: "#fff",
              borderRadius: "10px",
            },
          }}
        >
          <AddNewTag
            setOpenTag={setOpenTag}
            openTag={openTag}
            addTagHandler={(tag) => {
              formik.setFieldValue('formDetails.tags', [...formik.values?.formDetails?.tags, tag]);
            }}
            deleteTagHandler={(tag) => {
              const filteredTags = formik.values?.formDetails?.tags?.filter(
                (item) => item !== tag
              );
              formik.setFieldValue('formDetails.tags', filteredTags);
            }}
            selectedUserTag={formik.values?.formDetails?.tags || []}
            type="form"
            apiType="contact"
          />
        </Dialog>
      </div>
    </>
  );
};

export default FormInfo;